import { CameraControls } from '@react-three/drei';
import { useContext, useEffect, useRef } from 'react';

import { ViewContext } from '@/state/contexts';
import { logg } from '@/util/logg';

// TODO separate out payment mode and payment view
// Camera button to swap views
// if payment mode, swap to payment view
// if payment mode false, swap back to previous camera view
// OR, if payment mode or camState = payment, payment view
// if not paymentMode AND

// make camera view enum
// payment
// board

function CameraRig() {
	const controlsRef = useRef<CameraControls>(null);

	const { paymentMode, camState, isDraggingEnergy }: any =
		useContext(ViewContext);

	useEffect(() => {
		if (!controlsRef.current) return;

		if (paymentMode || camState === 'payment') {
			controlsRef.current.setLookAt(
				0,
				40,
				30, // camera position
				0,
				-25,
				0, // target
				true // smooth transition
			);

			controlsRef.current.enabled = false;
		} else if (camState === 'player') {
			controlsRef.current.setLookAt(0, 60, 60, 0, 0, 0, true);

			controlsRef.current.enabled = true;
		} else if (camState === 'overhead') {
			controlsRef.current.setLookAt(
				0,
				100,
				0, // camera position
				0,
				0,
				0, // target
				true // smooth transition
			);

			controlsRef.current.enabled = true;
		} else {
			controlsRef.current.setLookAt(0, 60, 60, 0, 0, 0, true);

			controlsRef.current.enabled = true;
		}
	}, [paymentMode, camState]);

	useEffect(() => {
		if (!controlsRef.current) return;
		if (isDraggingEnergy || paymentMode) {
			controlsRef.current.enabled = false;
			return;
		}
		controlsRef.current.enabled = true;
		logg('is Dragging energy: ', isDraggingEnergy);
	}, [isDraggingEnergy]);

	return <CameraControls ref={controlsRef} smoothTime={0.5} />;
}

export default CameraRig;
